/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTrainIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-train"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.65 15.75L3.65 5.95Q3.65 4.55 4.34 3.7Q5.03 2.85 6.17 2.4Q7.33 1.95 8.84 1.8Q10.35 1.65 12 1.65Q13.65 1.65 15.16 1.8Q16.68 1.95 17.82 2.4Q18.98 2.85 19.66 3.7Q20.35 4.55 20.35 5.95L20.35 15.75Q20.35 17.3 19.27 18.38Q18.2 19.45 16.65 19.45L17.1 19.9Q17.57 20.38 17.32 20.99Q17.07 21.6 16.4 21.6Q16.2 21.6 16 21.51Q15.8 21.43 15.68 21.3L13.82 19.45L10.18 19.45L8.32 21.3Q8.2 21.43 8 21.51Q7.8 21.6 7.6 21.6Q6.92 21.6 6.67 20.99Q6.42 20.38 6.9 19.9L7.35 19.45Q5.8 19.45 4.72 18.38Q3.65 17.3 3.65 15.75ZM5.9 9.85L10.9 9.85L10.9 7.1L5.9 7.1ZM13.15 9.85L18.1 9.85L18.1 7.1L13.15 7.1ZM8.45 16.3Q8.45 16.3 8.79 16.3Q9.13 16.3 9.61 15.81Q10.1 15.32 10.1 14.65Q10.1 13.97 9.61 13.49Q9.13 13 8.45 13Q7.78 13 7.29 13.49Q6.8 13.97 6.8 14.65Q6.8 15.32 7.29 15.81Q7.78 16.3 8.45 16.3ZM15.55 16.3Q15.55 16.3 15.89 16.3Q16.23 16.3 16.71 15.81Q17.2 15.32 17.2 14.65Q17.2 13.97 16.71 13.49Q16.23 13 15.55 13Q14.88 13 14.39 13.49Q13.9 13.97 13.9 14.65Q13.9 15.32 14.39 15.81Q14.88 16.3 15.55 16.3Z" fill={color} />
    </svg>
  );
}
